import React, { useContext, useState } from 'react'
import Modal from 'react-modal'
import { SaveOutlined, ArrowDropDown, Add, YoutubeSearchedFor } from '@material-ui/icons/'
import { Popover } from '@material-ui/core'

import SaveNewSearch from '../../HeadBar/SaveNewSearch/SaveNewSearch'
import SelectExistingSearch from '../../HeadBar/SelectExistingSearch/SelectExistingSearch'
import UpdateExistingSearch from '../../HeadBar/UpdateExistingSearch/UpdateExistingSearch'
import UpdateExistingList from '../../HeadBar/UpdateExistingList/UpdateExistingList'
import SaveNewList from '../../HeadBar/SaveNewList/SaveNewList'
import SelectExistingList from '../../HeadBar/SelectExistingList/SelectExistingList'
import myContext from '../../FiltersComponent/context/context'
import { isFilterApplied } from '../../Utility/Utility.js'
import ExportSearchButton from './ExportSearchButton'

const customStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -40%)',
        padding: '0px !important'
    },
    overlay: { zIndex: 1050 }
}

const SaveSearchButton = () => {
    const { searchCriteria, searchResult, setShowAlert, setalertProps, } = useContext(myContext)
    const [anchorEl, setAnchorEl] = useState(null)
    const [modalIsOpen, setIsOpen] = useState(false)
    const [selectedOption, setSelectedOption] = useState('')
    const [disableClose, setdisableClose] = useState(false)

    const handleSaveSearch = event => {
        if (isFilterApplied(searchCriteria)) {
            setAnchorEl(event.currentTarget)
        }
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    function openModal(inpuVal) {
        if (inpuVal === 'SaveNewList' || inpuVal === 'UpdateExistingList') {
            let index = searchResult.property.findIndex((prop) => {
                return prop.checked || (prop.omniViewPropertyId === searchCriteria.subjectProperty.omniViewPropertyId)
            })
            if (index == -1) {
                setalertProps({ message: `No Properties selected to save a list!!`, type: 'error' })
                setShowAlert(true)
                handleClose()
                return
            }
        }
        setSelectedOption(inpuVal)
        setIsOpen(true)
        handleClose()
    }

    function closeModal() {
        if (!disableClose) {
            setIsOpen(false)
        }
    }

    const componentToLoad = {
        SaveNewSearch: <SaveNewSearch handleClose={closeModal} ></SaveNewSearch>,
        SaveNewList: <SaveNewList handleClose={closeModal}></SaveNewList>,
        UpdateExistingSearch: <UpdateExistingSearch view="update" handleClose={closeModal}></UpdateExistingSearch>,
        UpdateExistingList: <UpdateExistingList view="update" handleClose={closeModal}></UpdateExistingList>,
        SelectExistingList: <SelectExistingList view="update" setdisableClose={setdisableClose} handleClose={closeModal}></SelectExistingList>,
        SelectExistingSearch: <SelectExistingSearch view="select" handleClose={closeModal}></SelectExistingSearch>
    }

    const open = Boolean(anchorEl)

    return (
        <>
            <button data-testid="test-button-save-menu" className={` py-2 btn btn-sm ${isFilterApplied(searchCriteria) ? '' : 'c-disabled'}`} onClick={handleSaveSearch}>
                <span className="px-1"><SaveOutlined /></span>
                <span className="px-2">Save</span>
                <span className=""><ArrowDropDown /></span>
            </button>
            {isFilterApplied(searchCriteria) && <ExportSearchButton />}
            <Popover open={open} anchorEl={anchorEl} onClose={handleClose} maxWidth={'md'}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }} >
                <div className="flex flex-col">
                    <div onClick={() => openModal('SaveNewList')}>
                        <div data-testid="test-menuItem-save-list" role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                            <div>
                                <Add></Add>
                            </div>
                            <div>
                                New list
                            </div>
                        </div>
                    </div>
                    <div onClick={() => openModal('SaveNewSearch')} >
                        <div data-testid="test-menuItem-save-search" role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                            <div>
                                <Add></Add>
                            </div>
                            <div>
                                New search
                            </div>
                        </div>
                    </div>
                    <div onClick={() => openModal('UpdateExistingList')}>
                        <div data-testid="test-menuItem-update-list" role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                            <div>
                                <YoutubeSearchedFor></YoutubeSearchedFor>
                            </div>
                            <div>
                                Add to an existing list
                            </div>
                        </div>
                    </div>
                    <div onClick={() => openModal('UpdateExistingSearch')} >
                        <div data-testid="test-menuItem-update-save" role="button" className="p-4 flex flex-row space-x-2 hover:bg-gray-2 cursor-context-menu hover:bg-gray-15">
                            <div>
                                <YoutubeSearchedFor></YoutubeSearchedFor>
                            </div>
                            <div>
                                Update an existing search
                            </div>
                        </div>
                    </div>
                </div>
            </Popover>
            <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={closeModal}
                closeTimeoutMS={500} style={customStyles} >
                {componentToLoad[selectedOption]}
            </Modal>
        </>
    )
}

export default SaveSearchButton
